<template>
  <div>
    <!-- 中间栏内容 -->
    <div class="lounge-content">
      <h3 role="title">{{ $t(title) }}</h3>
      <p class="lounge-content-desc1">{{ $t('views-lounge-desc1') }}</p>
      <p class="lounge-content-desc2">
        <span v-if="loungeData.type === 1">{{ $t('views-lounge-desc2') }}</span>
        <span v-if="loungeData.type === 2">{{ $t('views-lounge-desc3') }}</span>
        <span v-if="loungeData.type === 3">{{ $t('views-lounge-desc4') }}</span>
      </p>
    </div>

    <!-- 直接点击头部lounge -->
    <div class="lounge-card-list">
      <cards :options="loungeData" @cardClick="cardClick"></cards>
    </div>
  </div>
</template>

<script>
  import Cards from '@/components/BaseUi/AirportLoungeCards';

  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      loungeData: {
        type: Object,
        default: () => {},
      },
    },

    components: {
      Cards,
    },

    methods: {
      cardClick(data) {
        // 休息室
        this.loungeData.type === 1 &&
          this.$router.push({
            path: '/lounge/details',
            query: { loungeCode: data.code },
          });
        // 餐厅
        this.loungeData.type === 2 &&
          this.$router.push({
            path: '/dining/details',
            query: { diningCode: data.code },
          });
        // 零售店
        if (this.loungeData.type === 3) {
          // 如果是零售店需要对数据进行过滤
          const airportCode = this.loungeData.cards.find(item => {
            return item.airportCode === data.airportCode;
          });
          const retailCodes = this.loungeData.cards.find(item => {
            return item.code === data.code;
          });
          this.$router.push({
            path: '/retail/details',
            query: { airportCode: airportCode.airportCode, retailCodes: retailCodes.code },
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
  @import './mobile';
</style>
